export default {
  items: [
    {
      name: 'ค้นหาผู้ให้บริการขนส่ง',
      url: '/company/index',
      icon: 'fa fa-search-plus'
    },
    {
      name: 'หางานขนส่ง/ประกาศงานขนส่ง',
      url: '/quote-request',
      icon: 'fa fa-gavel',
      children: [
        {
          name: 'งานทั้งหมดในระบบ',
          url: '/quote-request/index/all'
        },
        {
          name: 'งานที่ฉันประกาศไว้',
          url: '/quote-request/index/myjob'
        },
        {
          name: 'งานที่ฉันเสนอราคาไว้',
          url: '/quote-request/index/myquoted'
        },
        {
          name: 'ประกาศงานขนส่งใหม่',
          url: '/quote-request/create'
        }
      ]
    },
    {
      name: 'กลุ่มของฉัน',
      icon: 'icon-people',
      url: '/mygroup/index'
    },
    {
      name: 'คู่มือการใช้งาน',
      icon: 'fa fa-book',
      url: 'http://bit.ly/LogistyManual',
      attributes: { target: '_blank' }
    },
    {
      name: 'ติดต่อเรา',
      url: '/contact-us',
      icon: 'fa fa-phone-square'
    }
  ]
}
